import { SUCCESS_SUFFIX, FAILURE_SUFFIX } from 'core/actions/apis';

const rootActionPath = 'core/BonusOffers';

export const BONUS_OFFERS_GET_SUCCESS = `${rootActionPath}/GET_${SUCCESS_SUFFIX}`;
export const BONUS_OFFERS_GET_FAILURE = `${rootActionPath}/GET_${FAILURE_SUFFIX}`;

export const BONUS_PENDING_OFFERS_GET_SUCCESS = `${rootActionPath}/PENDING/GET_${SUCCESS_SUFFIX}`;
export const BONUS_PENDING_OFFERS_GET_FAILURE = `${rootActionPath}/PENDING/GET_${FAILURE_SUFFIX}`;
